import React from 'react';
import { Emotion } from './types';
import './charts.css';
import { ML } from './mlstrings';
export class Chart extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: this.props.value ? this.props.value : 0,
        };
        this.capture = false;
        this.svgRef = React.createRef();
        this.gRef = React.createRef();
        this.pointerRef = React.createRef();
    }
    componentDidMount() {
        var _a, _b, _c, _d, _e, _f, _g;
        this.width = (_a = this.svgRef.current) === null || _a === void 0 ? void 0 : _a.width.baseVal.value;
        this.height = (_b = this.svgRef.current) === null || _b === void 0 ? void 0 : _b.height.baseVal.value;
        (_c = this.gRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
        (_d = this.gRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener('mousemove', this.onMouseMove.bind(this), { passive: false });
        (_e = this.pointerRef.current) === null || _e === void 0 ? void 0 : _e.addEventListener('mousedown', this.onPointerMouseDown.bind(this), { passive: false });
        (_f = this.gRef.current) === null || _f === void 0 ? void 0 : _f.addEventListener('touchmove', this.onMouseMove.bind(this), { passive: false });
        (_g = this.pointerRef.current) === null || _g === void 0 ? void 0 : _g.addEventListener('touchstart', this.onPointerMouseDown.bind(this), { passive: false });
        //        this.gRef.current?.addEventListener("touchstart", this.onPointerMouseDown.bind(this), {passive: false});
    }
    get value() {
        return this.state.value;
    }
    onWheel(event) {
        event.preventDefault();
        if (this.props.viewmode !== 'slider')
            return;
        let v = this.state.value;
        v = v - 0.1 * Math.sign(event.deltaY);
        if (v > 1)
            v = 1;
        if (v < 0)
            v = 0;
        if (v !== this.value && this.props.onChange !== undefined)
            this.props.onChange(v);
        this.setState({ value: v });
    }
    onBarClick(event) {
        const rect = event.currentTarget.getBoundingClientRect();
        const padding = 0;
        const elH = rect.height;
        let calcValue;
        const y = (event.type === 'touchmove' ? event.touches[0].clientY : event.clientY) -
            event.currentTarget.getBoundingClientRect().top;
        calcValue = 1 - (y - padding) / (elH - 2 * padding);
        if (calcValue < 0)
            calcValue = 0;
        if (calcValue > 1)
            calcValue = 1;
        calcValue = Math.round(calcValue * 10) / 10;
        if (calcValue !== this.value && this.props.onChange !== undefined)
            this.props.onChange(calcValue);
        this.setState({ value: calcValue });
    }
    onPointerMouseDown(event) {
        event.preventDefault();
        this.capture = true;
    }
    onMouseLeave(event) {
        if (this.capture)
            this.onBarClick(event);
        this.capture = false;
    }
    onMouseMove(event) {
        event.preventDefault();
        if (this.capture)
            this.onBarClick(event);
    }
    render() {
        let y;
        let h;
        switch (this.props.viewmode) {
            case 'chart': {
                const v = this.props.value !== undefined ? this.props.value : 0;
                y = `${(1 - v) * 100}%`;
                h = `${v * 100}%`;
                break;
            }
            case 'slider':
            default:
                y = '0';
                h = '100%';
        }
        return (React.createElement("svg", { ref: this.svgRef, xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', width: '100%', height: '10em', className: 'plutchik-chart-slider', onClick: () => (this.props.onClick ? this.props.onClick() : null), style: this.props.onClick ? { cursor: 'pointer' } : {} },
            this.props.viewmode === 'chart' ? (React.createElement("rect", { className: 'plutchik-dotted-frame', x: '0.25em', y: '0', width: '1em', height: '100%', style: { stroke: `var(--plutchik-${this.props.emotion}-color)` } })) : (React.createElement(React.Fragment, null)),
            React.createElement("g", { ref: this.gRef, onClick: this.onBarClick.bind(this), onMouseLeave: this.onMouseLeave.bind(this), onMouseUp: this.onMouseLeave.bind(this) },
                React.createElement("rect", { style: {
                        fill: `var(--plutchik-${this.props.emotion}-color)`,
                        cursor: this.props.viewmode === 'chart' ? 'default' : 'pointer',
                    }, x: '0.25em', y: y, width: '1em', height: h }),
                this.props.viewmode === 'slider' ? (React.createElement("rect", { ref: this.pointerRef, style: {
                        fill: `var(--plutchik-${this.props.emotion}-color)`,
                        stroke: 'white',
                        cursor: 'pointer',
                    }, x: '0em', y: `calc(${(1 - this.state.value) * 100}% - ${1 - this.state.value}em)`, width: '1.5em', height: '1em', rx: this.capture ? '0.1em' : '0.5em' })) : (React.createElement(React.Fragment, null))),
            React.createElement("g", { className: 'plutchik-emotion-text' },
                React.createElement("text", { style: { fill: `var(--plutchik-${this.props.emotion}-color)` }, x: '0', y: '100%' }, ML(this.props.emotion, this.props.language)))));
    }
}
export class Charts extends React.Component {
    onEmotionClick(emotion) {
        if (this.props.onClick)
            this.props.onClick(emotion);
    }
    render() {
        return (React.createElement("div", { className: 'plutchik-charts-container', style: {
                gridArea: this.props.gridArea,
                padding: this.props.label === undefined ? '0px' : undefined,
                borderWidth: this.props.label === undefined ? '0px' : undefined,
            } },
            this.props.label !== undefined ? (React.createElement("div", { className: 'plutchik-charts-label' }, this.props.label)) : (React.createElement(React.Fragment, null)),
            Object.values(Emotion).map((v, i) => {
                let val = this.props.vector[v];
                val = val ? val : 0;
                return (React.createElement(Chart, { viewmode: 'chart', disabled: false, value: val, emotion: v, key: i, onClick: this.props.onClick ? this.onEmotionClick.bind(this, v) : undefined }));
            })));
    }
}
